import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { supabase } from '../../lib/supabase';

export default function DebugProfile() {
  const { user, userProfile, userRole, loading, profileLoading } = useAuth();
  const [dbProfile, setDbProfile] = useState(null);
  const [dbError, setDbError] = useState(null);

  useEffect(() => {
    const fetchProfileDirectly = async () => {
      if (!user?.id) return;
      
      const { data, error } = await supabase
        .from('user_profiles')
        .select('*')
        .eq('id', user.id)
        .single();
      
      setDbProfile(data);
      setDbError(error);
    };

    fetchProfileDirectly();
  }, [user?.id]);

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Profile Debug Information</h1>
        
        <div className="space-y-6">
          {/* Loading State */}
          <div className="bg-white p-6 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4">Loading State</h2>
            <pre className="bg-gray-100 p-4 rounded overflow-auto">
              {JSON.stringify({ loading, profileLoading }, null, 2)}
            </pre>
          </div>

          {/* Auth User */}
          <div className="bg-white p-6 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4">Auth User (from context)</h2>
            <pre className="bg-gray-100 p-4 rounded overflow-auto">
              {JSON.stringify({
                id: user?.id,
                email: user?.email,
                created_at: user?.created_at
              }, null, 2)}
            </pre>
          </div>

          {/* User Profile from Context */}
          <div className="bg-white p-6 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4">User Profile (from AuthContext)</h2>
            <pre className="bg-gray-100 p-4 rounded overflow-auto text-sm">
              {JSON.stringify(userProfile, null, 2)}
            </pre>
          </div>

          {/* User Role from Context */}
          <div className="bg-white p-6 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4">User Role (from context)</h2>
            <div className="text-2xl font-bold text-blue-600">
              {userRole || 'undefined'}
            </div>
          </div>

          {/* Direct DB Query */}
          <div className="bg-white p-6 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4">Profile from Direct DB Query</h2>
            {dbError && (
              <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                Error: {dbError.message}
              </div>
            )}
            <pre className="bg-gray-100 p-4 rounded overflow-auto text-sm">
              {JSON.stringify(dbProfile, null, 2)}
            </pre>
          </div>

          {/* Expected Values */}
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6">
            <h2 className="text-xl font-semibold mb-4">Expected for Admin Access</h2>
            <ul className="list-disc list-inside space-y-2">
              <li><strong>userRole</strong> should be: <code className="bg-gray-200 px-2 py-1 rounded">admin</code></li>
              <li><strong>userProfile.role</strong> should be: <code className="bg-gray-200 px-2 py-1 rounded">admin</code></li>
              <li>Current actual role: <code className="bg-gray-200 px-2 py-1 rounded">{userRole}</code></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
